<div class="d-flex flex-row align-items-center gap-2 w-100" @fadeAnimation>
  <div class="flex-shrink-0" *ngIf="!iconRight">
    <img src="assets/img/play-icon.svg" style="width: 32px;" />
  </div>
  <div class="flex-grow-1 padding-text" [ngClass]="iconRight ? 'text-right' : ''">
    {{ text }}
    <span *ngIf="text2">
      - {{ text2 }}
    </span>
  </div>
  <div class="flex-shrink-0" *ngIf="iconRight">
    <img src="assets/img/play-icon.svg" style="width: 32px;" />
  </div>
</div>
